import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=3853fae6&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Product.vue?vue&type=style&index=0&id=3853fae6&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3853fae6",
  "b28c8db0"
  
)

component.options.__file = "Product.vue"
export default component.exports